var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2181 4.4H19.2737C20.4348 4.4 21.3848 5.255 21.3848 6.3V19.6C21.3848 20.645 20.4348 21.5 19.2737 21.5H4.49588C3.32421 21.5 2.38477 20.645 2.38477 19.6L2.39532 6.3C2.39532 5.255 3.32421 4.4 4.49588 4.4H5.55143V2.5H7.66254V4.4H16.107V2.5H18.2181V4.4ZM4.49588 19.6H19.2737V9.15H4.49588V19.6Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.80859,
    y: 10.4392,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48633,
    y: 12.0217,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48633,
    y: 13.6042,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48633,
    y: 15.1868,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.48633,
    y: 16.7693,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4688,
    y: 10.4392,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14648,
    y: 12.0215,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14648,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14648,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14648,
    y: 16.7695,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 10.4392,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80859,
    y: 12.0215,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80859,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80859,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80859,
    y: 16.7695,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7891,
    y: 10.4392,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 12.0215H12.2992V12.8128H11.4688V12.0215Z",
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4688,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4688,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4688,
    y: 16.7695,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7891,
    y: 12.0215,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7891,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7891,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4531,
    y: 10.4392,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 12.0215,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 16.7695,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4531,
    y: 12.0215,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4531,
    y: 13.604,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4531,
    y: 15.1865,
    width: 0.830438,
    height: 0.791272,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6c27435a1422622b5d500fb535eb4466.svg";
export { ForwardRef as ReactComponent };